export default "__VITE_ASSET__6SCSiiyp__"